<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title mainTitle="修改门禁设备" subheading="" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" disabled />
        <span v-html="deviceCodeVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备类型：</span>
        </div>
        <el-select v-model="deviceType" size="small" style="width: 280px">
          <el-option v-for="item in deviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturer" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelName" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接入协议:</span>
        </div>
        <el-select v-model="protocolType" size="small" style="width: 280px" :disabled="deviceType=='14'">
          <el-option v-for="item in protocolTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="deviceManufacturer === '100061' && deviceType !== '5' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备账号：</span>
        </div>
        <el-input v-model="userName" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="deviceManufacturer === '100061' && deviceType !== '5' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备密码：</span>
        </div>
        <el-input v-model="password" type="password" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="hasParent">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">所属网关：</span>
        </div>
        <el-select v-model="parentCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteParentMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in parentList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开门计划：</span>
        </div>
        <el-select v-model="openPlanId" size="small" style="width: 280px">
          <el-option v-for="item in openPlanIdList" :key="item.code"
                     :label="item.planName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应用场景：</span>
        </div>
        <el-select v-model="scence" size="small" style="width: 280px">
          <el-option v-for="item in scenceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="scence === '2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备所在房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="roomNumber" style="width: 280px" />
      </div>

      <div class="form-line" v-if="scence === '2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备所属住户：</span>
        </div>
        <el-select v-model="enterpriseCode" size="small" style="width: 280px">
          <el-option v-for="item in enterpriseList" :key="item.code"
                     :label="item.enterpriseName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进出类型：</span>
        </div>
        <el-select v-model="passType" size="small" style="width: 280px">
          <el-option v-for="item in passTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备用途：</span>
        </div>
        <el-select v-model="devicePurpose" size="small" style="width: 280px">
          <el-option v-for="item in devicePurposeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePerson"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirmModify" />
        <button-cancel @cancel="strategyCenter" />
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import {commonConfig} from '../common'
import {errorHandler} from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import {api} from '../../api/access-ctrl'
import {pattern} from '../../../utils/regular'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import {nError, nSuccess} from '../../../utils/notice'
import {treeApi} from '../../api/TreeApi'
import {bus} from '../../../utils/bus'

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: 'add-device',
  data () {
    return {
      config: {
        breadcrumb: [{
          value: '智慧门禁',
          name: 'accessCtrlDeviceManagementCenter'
        }, {
          value: '设备管理',
        }],
      },
      deviceName: '',
      deviceNameVer: '<span>不超过32个字</span>',
      deviceCode: '',
      deviceCodeVer: '',
      deviceManufacturer: '',
      deviceManufacturerList: [],
      deviceModelName: '',
      deviceModelNameList: [],
      protocolType: '',
      protocolTypeList: [
        {code: '主动注册', name: '主动注册'},
        {code: '大华云睿', name: '大华云睿'},
      ],
      openPlanId: '',
      openPlanIdList: [],
      enterpriseCode: '',
      enterpriseName: '',
      enterpriseList: [],
      organizationVer: '',
      deviceType: '',
      deviceTypeList: [
        {code: '1', name: '二维码云门禁一体机'},
        {code: '2', name: '二维码签到终端'},
        {code: '3', name: '人脸识别终端'},
        {code: '4', name: '人脸签到终端'},
        {code: '5', name: '二维码云门禁控制器'},
        {code: '6', name: '二维码核身终端'},
        {code: '7', name: '人脸闸机网关'},
         {code: '14', name: '门禁一体机'}
      ],
      scence: '1',
      scenceList: [
        {code: '1', name: '公共场景'},
        {code: '2', name: '住户场景'},
        {code: '4', name: '预约场景'},
        {code: '3', name: '其他场景'},
        {code: '5', name: '看房场景'}
      ],
      passType: '',
      passTypeList: [
        {code: '1', name: '进'},
        {code: '2', name: '出'},
        {code: '3', name: '进/出'},
      ],
      devicePurpose: '',
      devicePurposeList: [
        {code: '1', name: '仅门禁'},
        {code: '2', name: '仅考勤'},
        {code: '3', name: '门禁和考勤'},
      ],
      responsiblePerson: '',
      responsiblePersonList: [],
      responsiblePersonVer: '<span>门禁设备责任人</span>',
      hasParent: false,
      parentCode: '',
      parentName: '',
      parentList: [],
      hasResponsiblePerson: true,
      roomCode: '',
      roomNumber: '',
      deviceNameHttp: false,
      deviceCodeHttp: false,
      enterpriseHasRoomList: [],
      fetchDetail: null,
      organizationCode: '',
      organizationName: '',
      userName: '',
      password: '',
      location: '',
    }
  },
  created () {
    this.fetchDetail = () => {
      let treeList = []
      let yqCode = ''

      return treeApi.getYqInfo()
        .then(yqData => {
          let yqObj = {}
          yqCode = yqData.yqCode
          yqObj._value = yqData.yqCode
          yqObj._label = yqData.yqName
          yqObj.parentCode = '0'
          yqObj.level = 1
          yqObj.code = yqData.yqCode
          treeList.push(yqObj)

          treeApi.getVacancyRoomInfo(this.currentCode)
            .then(roomList => {
              roomList.map(room => {
                let roomObj = {}
                roomObj.buildingName = room.buildingName
                roomObj._value = room.code
                roomObj._label = room.roomNumber
                roomObj.parentCode = room.floorCode
                roomObj.level = 4
                roomObj.code = room.code
                roomObj.roomArea = room.roomArea
                roomObj.roomRent = room.roomRent
                roomObj.roomType = room.roomType
                treeList.push(roomObj)
              })
            })

          treeApi.getBuildingList()
            .then(buildingList => {
              buildingList.map(v => {
                let obj = {}
                obj._value = v.code
                obj._label = v.name
                obj.parentCode = yqCode
                obj.level = 2
                obj.code = v.code
                treeList.push(obj)
                if (v.floors.length > 0) {
                  v.floors.map(floor => {
                    let floorObj = {}
                    floorObj._value = floor.code
                    floorObj._label = floor.name
                    floorObj.parentCode = floor.buildingCode
                    floorObj.level = 3
                    floorObj.code = floor.code
                    treeList.push(floorObj)
                  })
                }
              })

            })
          return treeList
        })
    }
    this.getAllDeviceManufacture()
    this.getAllDeviceType()
    this.getOpenPlanList()

    this.getGatewayDeviceList()
    // this.getBuildingData()
    setTimeout(() => {
      this.getAccessDeviceData(this.$route.params.id)
    }, 50)
  },
  methods: {
    remoteParentMethod (query) {
      this.getGatewayDeviceList(query)
    },
    // 获取网关列表
    getGatewayDeviceList (query) {
      api.getGatewayDeviceList({
        searchKey: query || ''
      })
        .then(data => {
          data.forEach(it => {
            it._value = it.deviceCode
            it._label = it.deviceName
          })
          this.parentList = data
        })
        .catch(errorHandler('获取网关列表失败'))
    },
    getEnterpriseByCode (code) {
      api.getEnterpriseByCode(code)
        .then(data => {
          let enterpriseHasRoomCode = data.roomCode.split(',')
          let enterpriseHasRoomNumber = data.roomNumber.split(',')
          for (let i = 0; i < enterpriseHasRoomCode.length; i++) {
            let obj = {}
            obj.code = enterpriseHasRoomCode[i]
            obj.name = enterpriseHasRoomNumber[i]
            this.enterpriseHasRoomList.push(obj)
          }
        })
        .catch(errorHandler('获取租赁信息失败'))
    },
    getAccessDeviceData (id) {
      api.getAccessDeviceByCode(id)
        .then(data => {
          this.deviceName = data.deviceName
          this.deviceCode = data.deviceCode
          this.deviceManufacturer = data.deviceManufacturerCode
          this.deviceModelName = data.deviceModelCode
          this.protocolType = data.protocolType
          this.scence = data.scence
          this.openPlanId = data.openPlanCode
          this.enterpriseCode = data.enterpriseCode
          this.enterpriseName = data.enterpriseName
          this.responsiblePerson = data.responsiblePersonCode
          this.deviceType = data.deviceType
          this.passType = data.passType
          this.devicePurpose = data.devicePurpose
          this.roomCode = data.roomCode
          this.roomNumber = data.roomNumber
          this.parentCode = data.parentCode
          this.parentName = data.parentName
          this.userName = data.userName
          this.password = data.password
          this.location = data.location
          this.getAllDeviceType(+this.deviceType + 4)
          this.remoteMethod(data.responsiblePersonName)
          this.getEnterpriseListByRoom()
        })
        .catch(errorHandler('获取设备数据失败'))
    },
    // 获取房间下的住户
    getEnterpriseListByRoom () {
      api.getEnterpriseListByRoom({
        roomInfoCode: this.roomCode
      })
        .then(data => {
          this.enterpriseList = data
        })
        .catch(errorHandler('获取住户失败'))
    },
    getEnterpriseInfoList () {
      api.getEnterpriseInfoList()
        .then(data => {
          this.enterpriseList = data
          this.enterpriseList.map(v => {
            if (v.code === this.enterpriseCode) {
              this.enterpriseName = v.enterpriseName
            }
          })
        })
        .catch(errorHandler('获取住户信息失败'))
    },
    getAllDeviceManufacture () {
      api.getAllDeviceManufacture({
        moduleCode: '1',
        deviceType: this.deviceType
      })
        .then(data => {
          this.deviceManufacturerList = data
          this.getAllDeviceType()
        })
        .catch(errorHandler('获取设备厂家失败'))
    },
    getAllDeviceType () {
      api.getAllDeviceType({
        moduleCode: '1',
        deviceType: this.deviceType,
        deviceManufactureCode: this.deviceManufacturer
      })
        .then(data => {
          this.deviceModelNameList = data
        })
        .catch(errorHandler('获取设备型号失败'))
    },
    getOpenPlanList () {
      api.getOpenPlanList()
        .then(data => {
          this.openPlanIdList = data
        })
        .catch(errorHandler('获取开门计划失败'))
    },
    getResponsiblePersonList (searchKey) {
      api.getResponsiblePerson(searchKey || '')
        .then(list => {
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
    },
    // 查询企业管理员
    getEnterprisePerson (searchKey) {
      api.getEnterprisePerson({
        searchKey: searchKey || '',
        enterpriseCode: this.enterpriseCode,
        cardTypeCode: `${bus.global.yqCode}A00000003`,
      })
        .then(list => {
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
    },
    // getBuildingData () {
    //   this.$axios.post(httpUrl.test + this.school + '/dorm/dormitory/getList', {})
    //     .then((res) => {
    //       let list = res.body.data
    //       for (let i = 0; i < list.length; i++) {
    //         if (list[i].level === '4') {
    //           this.Carr.push(list[i])
    //         }
    //         if (list[i].level === '3') {
    //           list[i].build = []
    //           this.Barr.push(list[i])
    //         }
    //         if (list[i].level === '2') {
    //           list[i].build = []
    //           this.Aarr.push(list[i])
    //         }
    //       }
    //       for (let m = 0; m < this.Barr.length; m++) {
    //         for (let n = 0; n < this.Carr.length; n++) {
    //           if (this.Barr[m].id === this.Carr[n].parentId) {
    //             this.Barr[m].build.push(this.Carr[n])
    //           }
    //         }
    //       }
    //       for (let m = 0; m < this.Aarr.length; m++) {
    //         for (let n = 0; n < this.Barr.length; n++) {
    //           if (this.Aarr[m].id === this.Barr[n].parentId) {
    //             this.Aarr[m].build.push(this.Barr[n])
    //           }
    //         }
    //       }
    //       this.buildingData = this.Aarr
    //     })
    //     .catch(errorHandler('获取数据失败'))
    // },
    remoteMethod (query) {
      if (this.scence === '2') {
        this.getEnterprisePerson(query)
      } else {
        this.getResponsiblePersonList(query)
      }
    },
    getRoomList (v) {
      this.roomCode = v.code
      this.roomNumber = v.buildingName + v._label
    },
    confirmModify () {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>'
        return false
      }
      if (!this.deviceCode) {
        this.deviceCodeVer = '<span style="color: red;">请输入设备编号</span>'
        return false
      }
      // if (!this.organizationId) {
      //   this.organizationVer = '<span style="color: red;">请选择设备组织</span>'
      //   return false
      // }
      // if (!this.responsiblePerson) {
      //   this.responsiblePersonVer = '<span style="color: red;">请选择设备责任人</span>'
      //   return false
      // }
      if (this.scence === '2' && !this.roomCode && !this.enterpriseCode ) {
        this.responsiblePersonVer = '<span style="color: red;">请选择设备所在房间及住户</span>'
        return false
      }
      if (!this.deviceCodeHttp || !this.deviceNameHttp) {
        return false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceCodeVer = ''
        this.responsiblePersonVer = '<span>门禁设备责任人</span>'
      }
      if (this.deviceManufacturer === '100061' && this.deviceType !== '5' && (!this.userName || !this.password)) {
        nError('请输入设备账户和密码')
        return false
      }
      let obj = {
        'deviceName': this.deviceName,
        'deviceCode': this.deviceCode,
        'deviceManufacturerCode': this.deviceManufacturer,
        'deviceManufacturerName': '',
        'deviceModelCode': this.deviceModelName,
        'deviceModelName': '',
        'protocolType': this.protocolType,
        'openPlanCode': this.openPlanId,
        'enterpriseCode': this.enterpriseCode,
        'enterpriseName': '',
        'organizationCode': this.organizationCode,
        'organizationName': this.organizationName,
        'planName': '',
        'responsiblePersonId': '',
        'responsiblePersonName': this.responsiblePerson,
        'responsiblePersonCode': '',
        'deviceManufacturer': this.deviceManufacturer,
        'scence': this.scence,
        'scenceName': '',
        'passType': this.passType,
        devicePurpose: this.devicePurpose,
        'roomCode': this.roomCode,
        'roomNumber': this.roomNumber,
        'deviceType': this.deviceType,
        'parentCode': this.parentCode,
        'parentName': this.parentName,
        userName: this.userName,
        password: this.password,
        'location': this.location
      }
      if (this.scence !== '2') {
        obj.roomCode = ''
      }
      this.openPlanIdList.map(v => {
        if (v.code === this.openPlanId) {
          obj.planName = v.planName
        }
      })
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name
        }
      })
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name
        }
      })
      this.scenceList.map(v => {
        if (v.code === this.scence) {
          obj.scenceName = v.name
        }
      })
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePerson) {
          obj.responsiblePersonName = v._label
          obj.responsiblePersonCode = v.code
        }
      })
      this.enterpriseList.map(v => {
        if (v.code === this.enterpriseCode) {
          obj.enterpriseName = v.enterpriseName
        }
      })
      api.patchAccessDevice(obj)
        .then(() => {
          nSuccess('修改成功')
          this.$router.push({
            path: '/access-control/device/center'
          })
        })
        .catch(errorHandler('修改门禁设备失败'))
    },
    strategyCenter () {
      this.$router.push({
        path: '/access-control/device/current/' + this.$route.params.id
      })
    }
  },
  watch: {
    deviceType (v) {
      if (this.deviceType === '3' || this.deviceType === '4') {
        this.hasResponsiblePerson = false
      } else {
        this.hasResponsiblePerson = true
      }
      this.getAllDeviceManufacture()
    },
    deviceName (v) {
      let ptn = pattern.basicAndCN.test(v)
      if (!ptn) {
        this.deviceNameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
        this.deviceNameHttp = false
      } else {
        this.deviceNameVer = '<span>不超过32个字</span>'
        this.deviceNameHttp = true
      }
    },
    deviceCode (v) {
      let ptn = pattern.abd123.test(v)
      if (!ptn) {
        this.deviceCodeVer = '<span style="color: red;">只允许输入字母，数字</span>'
        this.deviceCodeHttp = false
      } else {
        this.deviceCodeVer = ''
        this.deviceCodeHttp = true
      }
    },
    scence (v) {
      if (v === '2') {

        // this.getEnterpriseInfoList()
        // this.getEnterpriseByCode(this.enterpriseCode)
      }
    },
    roomCode () {
      if (this.scence === '2') {
        this.getEnterpriseListByRoom()
        this.getEnterprisePerson()
      }
    },
    enterpriseCode () {
      this.getEnterprisePerson()
    },
    deviceManufacturer (v) {
      if (v === '100080') {
        this.hasParent = true
      }
      this.getAllDeviceType()
    },
    parentCode () {
      this.parentList.map(v => {
        if (v.deviceCode === this.parentCode) {
          this.parentName = v.deviceName
        }
      })
    },
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/AccessCtrl/device-management/modify-device.vue